import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './SectionRotate.module.css';

const SectionRotate = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.sectionRotateLeft}>
        <p className={css.customParagraph}>
          ROTATE exists to bring like-minded
          <br />
          New Zealanders together to buy
          <br />
          and sell furniture and interiors.
          <br />
          We believe timeless design has
          <br />
          many lives and want you
          <br />
          to see old things in new ways.
        </p>
      </div>

      <div className={css.sectionRotateCenter}>
        <p>
          ROTATE
          <br />
          THE OLD
          <br />
          INTO NEW
        </p>
      </div>

      <div className={css.sectionRotateRight}>
        <p className={css.customParagraph}>
          ROTATE supports more sustainable living,
          <br />
          starting from inside the home.
          <br />
          Our platform allows for continuous exchange,
          <br />
          eliminating the need to purchase new.
        </p>
      </div>
    </div>
  );
};

SectionRotate.defaultProps = {
  rootClassName: null,
  className: null
};

const { string } = PropTypes;

SectionRotate.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionRotate;
